<button class="btn btn-primary-dark float-right border-0 offer-button margin-right-5" type="button"
  (click)="openConsider()">
  <i class="fa fa-chevron-right offer-icon-left"></i><i class="fa fa-chevron-right offer-icon-right"></i>提案管理
</button>